import FooterSimplifiedContainer from './FooterSimplifiedContainer';

export default FooterSimplifiedContainer;
